import type { AxiosError } from 'axios';
import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import * as collectionsApi from '@hotjar/webapp/domains/collections/api';
import { queryClient } from '@hotjar/webapp/utils/react-query';

type ApiFunction = typeof collectionsApi.remove;
type ApiResponseType = Awaited<ReturnType<ApiFunction>>;

export function useCollectionRemove(
  siteId: Parameters<ApiFunction>[0] | null,
  collectionId: Parameters<ApiFunction>[1],
): UseMutationResult<ApiResponseType, AxiosError> {
  return useMutation(
    async () => {
      if (siteId === null) {
        throw new Error('site ID is not defined');
      }

      return collectionsApi.remove(siteId, collectionId);
    },
    {
      onSuccess() {
        queryClient.invalidateQueries(collectionsApi.COLLECTIONS_LIST_QUERY_KEY);
      },
    },
  );
}
